import { Graticule, Mercator } from '@visx/geo';
import * as topojson from 'topojson-client';
import { colors } from 'ui-components';

import topology from './topology.json';

const background = '#fff';
const countryBg = colors.primary[400] + '80';
const countryActivated = colors.primary[400];

type GeoMercatorProps = {
  width: number;
  height: number;
  data: {
    country: string;
    value: number;
  }[];
  isModal?: boolean;
};

interface FeatureShape {
  type: 'Feature';
  id: string;
  geometry: { coordinates: [number, number][][]; type: 'Polygon' };
  properties: { name: string };
}

// Taken from: https://airbnb.io/visx/geo-mercator
// This component pretty much draws a world map svg based on co-ordinates provided in the topojson file
// @ts-expect-error
const world = topojson.feature(topology, topology.objects.units) as {
  type: 'FeatureCollection';
  features: FeatureShape[];
};

export const CountryMap = ({
  width,
  height,
  data,
  isModal,
}: GeoMercatorProps) => {
  const centerX = width / 2;
  const centerY = height / 2;
  const scale = (width / 630) * 100;

  return width < 10 ? null : (
    <svg width={width} height={height}>
      <rect
        x={0}
        y={0}
        width={width}
        height={height}
        fill={background}
        rx={14}
      />
      <Mercator<FeatureShape>
        data={world.features}
        scale={scale}
        translate={[centerX, centerY + (!isModal ? 50 : 20)]}
      >
        {(mercator) => (
          <g>
            <Graticule
              graticule={(g) => mercator.path(g) || ''}
              stroke="#fff" // border
            />
            {mercator.features.map(({ feature, path }, i) => {
              const highlighted = data.find(
                (d) => d.country === feature.properties.name,
              );

              return (
                <path
                  key={`map-feature-${i}`}
                  d={path || ''}
                  fill={highlighted ? countryActivated : countryBg}
                  stroke={highlighted ? countryActivated : '#fff'}
                  strokeWidth={highlighted ? 3 : 0.25}
                />
              );
            })}
          </g>
        )}
      </Mercator>
    </svg>
  );
};
